/**
 * Provider naming for native journey screens. New purchases are billed by the
 * platform's store; an existing subscription belongs to whoever sold it
 * (`snapshot.store`), which can differ from the current device.
 */
import { Platform } from 'react-native';
import type { SubscriptionSnapshot } from '@tabbio/types';
import { purchaseProviderKey } from '@/lib/subscription-journey/checkout-flow';
import type { JourneyIconName } from './journey-icons';

/** `common` key for the provider that owns an existing subscription. */
export function providerKeyForStore(store: SubscriptionSnapshot['store'] | undefined) {
  if (store === 'app_store') return 'subscription.providers.appStore';
  if (store === 'play_store') return 'subscription.providers.googlePlay';
  return 'subscription.providers.web';
}

export function providerIconForStore(
  store: SubscriptionSnapshot['store'] | undefined,
): JourneyIconName {
  if (store === 'app_store') return 'apple';
  if (store === 'play_store') return 'play';
  return 'card';
}

/** `common` key for a NEW purchase on this device. */
export function newPurchaseProviderKey() {
  return purchaseProviderKey(Platform.OS);
}

/** Store-owned subscriptions restore; web/portal ones refresh. */
export function isStoreOwned(store: SubscriptionSnapshot['store'] | undefined) {
  return store === 'app_store' || store === 'play_store';
}
